// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-card_layout__q8V1g","photoContainer":"speaker-card_photoContainer__3PEsn","photo":"speaker-card_photo__dJVqM"};